module.exports = __webpack_public_path__ + "img/nav_arrow.a31cdaf0.svg";